import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { getCancelTrip } from "redux/actions/UserCustomerTrip";
import CommonDialog from "components/commonDialog/CommonDialog";

export default function CancelRefund(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(true);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
    props?.handleClose(open);
  };

const onClickCancel = () =>{
  const tripData = {
    status :'Cancel',
    cancelReason: props?.reason,
    id:props?.tripId,
  }
    dispatch(getCancelTrip(tripData,navigate))
}

  const handleCheckboxChange = () => {
    setIsCheckboxChecked((prevValue) => !prevValue);
  };

  return (
    <div>
      <CommonDialog
      open={open}
      handleClose={handleClose}
      isCheckboxChecked={isCheckboxChecked} 
      handleCheckboxChange={handleCheckboxChange}
      onClickCancel={onClickCancel}
      handleClickOpen={props?.handleClickOpen}
      cancelRefund={true}
      tripId={props?.tripId}
      reason={props?.reason}
      refundPriceData={props?.refundPriceData}
    />
    </div>
  );
}
